export const HISTORY_PRICES_CONCEALED_STATE = 'TX';

export const ADVERTISED_PRICE_SOURCE = {
  DEALER_MSRP: 'dealerMsrp',
  DEALER_MSRP_FEES_INCLUDED: 'dealerMsrpFeesIncluded',
  INTERNET_PRICE: 'internetPrice',
};

export const DEALER_FEE_CONFIGURATIONS = {
  HAS_FEES: 'HAS_FEES',
  NO_FEES: 'NO_FEES',
  UNKNOWN: 'UNKNOWN',
};

export const HAS_FEES_TEXT = 'Includes dealer fees';
export const HAS_FEES_TEXT_SHORT = 'Inc. dealer fees';
export const NO_FEES_TEXT = 'No additional fees';
export const UNKNOWN_FEES_TEXT = 'Fees not disclosed';

export const UNKNOWN_FEES_DISCLAIMER = 'Edmunds has not received fee details for this dealer.';

export const DEALER_PRICE_DISCLAIMER = 'Does not include taxes, registration or other government fees.';
